/**
 * The content kinds an organization can publish to its newsroom.
 *
 * This is the client-side mirror of the CHECK constraint on
 * `public.organization_content.type` — the database is the enforcement
 * boundary, and an insert carrying a value the constraint does not admit
 * raises `organization_content_type_check` and surfaces to the admin as a
 * generic "Failed to save content" toast. Both the admin editor
 * (ContentPublishingPage) and the public newsroom (newsContent.ts) read from
 * here, so there is exactly one client list to keep aligned with the schema.
 *
 * `src/lib/organizationContentTypes.test.ts` parses the migration chain for
 * the latest definition of that constraint and fails when this list drifts
 * from it in either direction. Add a value here only together with the
 * migration that widens the constraint — a migration lands on `compaire-dev`
 * first, so sequence the bundle after it. (A fifth kind, `team_news`, was
 * offered by the client from 2026-03-26 with no such migration and could
 * never be saved; it was removed in 2026-09 rather than added to the schema.)
 *
 * Deliberately dependency-free: the test imports this module directly, and
 * anything that pulled in the Supabase client would throw at import time
 * without the runtime environment variables.
 *
 * The list itself is defined under supabase/functions/_shared and re-exported
 * here (the orgProfileOptions.ts arrangement): the `import-org-content` edge
 * function validates the model's suggested type against exactly this list.
 */
export {
  ORGANIZATION_CONTENT_TYPES,
  isOrganizationContentType,
} from "../../supabase/functions/_shared/organizationContentTypes";
export type { OrganizationContentType } from "../../supabase/functions/_shared/organizationContentTypes";
import type { OrganizationContentType } from "../../supabase/functions/_shared/organizationContentTypes";

export const ORGANIZATION_CONTENT_TYPE_LABELS: Record<OrganizationContentType, string> = {
  press: "Press Release",
  milestone: "Milestone",
  new_agent: "New Hire",
  announcement: "Announcement",
};
